import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddEditClassBaseRequestBody } from '../base/base.types';
import { Base, ClassBase, EditBaseRequestBody } from './base.types';


export const useBases = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: 'bases',
    queryFn: () => apiClient.get<Base[]>('/bases'),
    enabled,
  });
}
  
  export const useBase = (requestBody: { baseNo: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Base>>({
    queryKey: ['base', requestBody.baseNo],
    queryFn: () => apiClient.get<Base>(`/bases/${requestBody.baseNo}`, { params: requestBody }),
    enabled,
  });
};

export const useEditBase = (baseNo: string) => {
  return useMutation((requestBody: EditBaseRequestBody) => {
    return apiClient.put(`/bases/${baseNo}`, requestBody);
  });
};

export const useClassBases = (
  requestBody: { classNo?: string; baseNo?: string; status?: number },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<ClassBase[]>>({
    queryKey: ['bases', requestBody.classNo, requestBody.baseNo, requestBody.status],
    queryFn: () => apiClient.get<ClassBase[]>('/class-bases', { params: requestBody }),
    enabled,
  });
};

export const useAddClassBase = () => {
  return useMutation(( requestBody: AddEditClassBaseRequestBody ) => {
    return apiClient.post<ClassBase>(`/class-bases?classNo=${requestBody.classNo}&baseNo=${requestBody.baseNo}`, requestBody );
  });
};

export const useDeleteClassBase = () => {
  return useMutation((classNoAndBaseNo: {classNo: number | undefined, baseNo: number | undefined}) => {
    return apiClient.delete(`/class-bases/${classNoAndBaseNo.classNo}`, { params:  {baseNo: classNoAndBaseNo.baseNo} });
  });
};

export const useGetRecipeBases = (
    requestBody: { classNo: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getRecipeBases', requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>('/recipes/bases', { params: requestBody }),
    enabled
  });
};

export const useGetSubRecipeBases = (
    requestBody: { classNo: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getSubRecipeBases', requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>('/sub-recipes/bases', { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemRecipeBases = (
    menuNo: string,
    requestBody: { classNo?: number; strategyNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getMenuItemRecipeBases', menuNo, requestBody.classNo, requestBody.strategyNo],
    queryFn: () => apiClient.get<Base[]>(`/menus/${menuNo}/items/recipes/bases`, { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemSubRecipeBases = (
  menuNo: string,
  requestBody: { classNo?: number },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getMenuItemSubRecipeBases', menuNo, requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>(`/menus/${menuNo}/items/sub-recipes/bases`, { params: requestBody }),
    enabled
  });
};
